import React, { Dispatch, SetStateAction, useMemo } from 'react'

import { Button, Grid, Typography } from '@barracuda-internal/bds-core'

import { useFormatMessage } from 'lib/localization'
import styles from 'components/pages/inboundSettings/inboundSettingsStyles'
import DomainTable from 'components/libs/domainTable/DomainTable'
import { useIsReadonly } from 'lib/hooks/useIsReadonly'
import { useLanguagePolicyExemptLogic } from './useLanguagePolicyExemptLogic'

const BASE_I18N_KEY = 'ess.inbound_settings.regional_policies'
const BASE_INBOUND_I18N_KEY = 'ess.inbound_settings'

export interface LanguagePolicyExemptProps {
  delegateDirtyFormState: Dispatch<SetStateAction<boolean>>
}

const LanguagePolicyExempt: React.FC<LanguagePolicyExemptProps> = (props: LanguagePolicyExemptProps) => {
  const isReadonly = useIsReadonly()
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  const formatInboundMessage = useFormatMessage(BASE_INBOUND_I18N_KEY)
  const inboundClasses = styles()
  const [state, eventHandlers] = useLanguagePolicyExemptLogic()

  return useMemo(
    () => (
      <Grid container>
        <Grid container className={inboundClasses.spaceGrid}>
          <Typography variant="h4">{formatMessage('language_policy_exemptions')}</Typography>
          <Button
            className={inboundClasses.bulkEdit}
            onClick={eventHandlers.onBulkEdit}
            variant="contained"
            size="small"
            data-testid="bulk-button-language-exempt"
            disabled={isReadonly}
          >
            {formatInboundMessage('bulk_edit')}
          </Button>
        </Grid>
        <DomainTable
          data={state.tableData}
          onAddItem={eventHandlers.onAddItem}
          onRemoveItem={eventHandlers.onRemoveItem}
          shouldHandleEmail
          isLoading={state.isLoading}
          data-testid="language-policy-exempt-table"
          delegateDirtyFormState={props.delegateDirtyFormState}
        />
      </Grid>
    ),
    [
      formatMessage,
      formatInboundMessage,
      inboundClasses.spaceGrid,
      inboundClasses.bulkEdit,
      eventHandlers,
      state.tableData,
      state.isLoading,
      isReadonly,
      props.delegateDirtyFormState
    ]
  )
}

export default LanguagePolicyExempt
